import Vue from '@/setup'
import Router from 'vue-router'

/**
 * Overwrites the push-method of vue-router to surpress the error from route-guards
 */
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

import advisoryProtocolRoutes from '@/modules/Configurator/routes/advisoryProtocol'
import applicationRoutes from '@/modules/Configurator/routes/application'
import basketRoutes from '@/modules/Configurator/routes/basket'
import digitalSignatureRoutes from '@/modules/Configurator/routes/digitalSignature'
import nextStepsRoutes from '@/modules/Configurator/routes/nextSteps'
import partnerRoutes from '@/modules/Configurator/routes/partner'
import personRoutes from '@/modules/Configurator/routes/person'
import productRoutes from '@/modules/Configurator/routes/product'
import reentryRoutes from '@/modules/Configurator/routes/reentry'
import submitRoutes from '@/modules/Configurator/routes/submit'
import aideRoutes from '@/modules/Configurator/routes/aide'
import cobrowseRoutes from '@/modules/Configurator/routes/cobrowse'

import { ApplicationHelper, LogHelper, TrackerHelper, SessionHelper } from '@/helpers'

import { EVENT_ERROR, EVENT_READY } from '@/config/events'

const { $EventBus, $session } = Vue.prototype

Vue.use(Router)

const routes = [
  ...advisoryProtocolRoutes,
  ...aideRoutes,
  ...applicationRoutes,
  ...basketRoutes,
  ...digitalSignatureRoutes,
  ...nextStepsRoutes,
  ...partnerRoutes,
  ...personRoutes,
  ...productRoutes,
  ...reentryRoutes,
  ...submitRoutes,
  ...cobrowseRoutes,
  {
    id: 'root',
    name: 'root',
    path: '/',
    redirect: '/persons',
  },
]

const router = new Router({
  routes,
  scrollBehavior(to, _from, _position) {
    if (to.meta?.scrollTop === false) return

    window.setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      })
    })
  },
})

router.beforeEach((to, from, next) => {
  const disableNavigation =
    (window.OVP_APP_DISABLE_NAVIGATION || from.meta.disableNavigation) && !to.query?.forcedRouting
  if (disableNavigation) {
    return next(false)
  }

  const params = to.params
  const needsSession = to.meta?.secured ?? true

  const language = ApplicationHelper.getLanguage().toUpperCase()

  params.language = params.language || language

  if (needsSession && !$session.isActive()) {
    SessionHelper.autostart(params)
      .then(() => {
        next()
        // AIDE triggers it's own EVENT_READY, otherwise DVP shines through on load
        if (!to.meta.aide) {
          $EventBus.$emit(EVENT_READY)
        }
      })
      .catch(error => {
        LogHelper.error(error)

        if (params.collective) {
          $EventBus.$emit(EVENT_ERROR, {
            eval: true,
            error: 'error.COLLECTIVE_UNAVAILABLE',
          })
        } else {
          $EventBus.$emit(EVENT_ERROR, {
            eval: true,
            error: 'error.NETWORK',
          })
        }
      })
  } else {
    next()
  }
})

router.afterEach((to, from) => {
  try {
    TrackerHelper.trackRoute(to, from)
  } catch (error) {
    LogHelper.error(error)
  }
  if (window.ineum) {
    window.ineum('page', to.name)
  }
})

/**
 * ONLY FOR AIDE!
 * When we're in aide, we need to wait for the routing to be resolved (async components).
 * Otherwise, the DVP-Styles will (Header/Footer) will be rendered first
 */
router.onReady(route => {
  if (route.name.includes('aide')) {
    $EventBus.$emit(EVENT_READY)
  }
})

export default router
